

<main class="flex-1 max-w-[1500px] mx-auto w-full px-7 lg:px-12 py-9">

    <!-- Success Message -->
    <div *ngIf="successMessage"
        class="mb-4 p-[18px] rounded-lg bg-green-50 border border-green-200 text-green-700 flex items-center gap-2 text-sm">

        <span class="material-symbols-outlined text-[20px]">check_circle</span>
        {{ successMessage }}

    </div>

    <!-- Error Message -->
    <div *ngIf="errorMessage"
        class="mb-4 p-[18px] rounded-lg bg-red-50 border border-red-200 text-red-700 flex items-center gap-2 text-sm">

        <span class="material-symbols-outlined text-[20px]">error</span>
        {{ errorMessage }}

    </div>

    <!-- TITLE -->
    <div class="flex flex-col md:flex-row justify-between items-start md:items-center gap-3 mb-5">

        <div>
            <h2 class="text-[22px] font-bold text-slate-900 tracking-tight">
                Role Management
            </h2>

            <p class="text-sm text-slate-500 mt-1">
                Configure website locales and translations.
            </p>
        </div>

        <button (click)="addNew()"
            class="flex items-center gap-2 bg-primary hover:bg-primary/90 text-white px-3.5 py-2 rounded-md font-semibold shadow transition-all text-sm">

            <span class="material-symbols-outlined text-[20px]">add</span>
            <span>Add</span>

        </button>

    </div>

    <div class="flex border-b border-slate-200 mb-4 gap-6">
        
        <!-- Dynamic Languages -->
        <button
            *ngFor="let lang of languages"
            (click)="setTab(lang.code)"
            class="pb-3 px-6 text-base font-semibold border-b-2 transition-all flex items-center gap-2"
            [class.text-primary]="activeTab === lang.code"
            [class.border-primary]="activeTab === lang.code">

            <img
                [src]="lang.icon"
                class="w-6 h-6 rounded-full object-cover border border-slate-200">

            {{ lang.name }} ({{ getLanguageCount(lang.code) }})

        </button>

    </div>

    <div class="mb-4 max-w-[420px]">
        <input type="text" [(ngModel)]="searchText" (ngModelChange)="filterRoles(activeTab)"
            placeholder="Search roles"
            class="w-full border border-slate-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
    </div>

    <!-- TABLE -->
    <div class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">

        <div class="overflow-x-auto">

            <table class="w-full text-left border-collapse">

                <thead>
                    <tr class="bg-slate-50 border-b border-slate-200">

                        <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase">
                            Role Name
                        </th>

                        <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase">
                            Description
                        </th>

                        <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase text-center">
                            Language
                        </th>

                        <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase text-right">
                            Actions
                        </th>

                    </tr>
                </thead>

                <tbody class="divide-y divide-slate-100">

                    <tr *ngFor="let role of filteredRoles" class="hover:bg-slate-50 transition-colors">

                        <!-- Role Name -->
                        <td class="px-3.5 py-2.5 text-xs font-semibold text-slate-900">
                            {{ role.name }}
                        </td>

                        <!-- Description -->
                        <td class="px-3.5 py-2.5 text-xs text-slate-600">
                            {{ role.description }}
                        </td>

                        <!-- Language -->
                        <td class="px-3.5 py-2.5 text-center">
                            <span class="text-xs text-slate-600">
                                {{ role.languageCode }}
                            </span>
                        </td>

                        <!-- Actions -->
                        <td class="px-3.5 py-2.5 text-right">

                            <div class="flex justify-end gap-2">

                                <button
                                    class="p-1.5 text-slate-400 hover:text-primary"
                                    (click)="viewData(role.roleId,'Edit')">
                                    <span class="material-symbols-outlined text-[20px]">edit</span>
                                </button>

                                <button
                                    class="p-1.5 text-slate-400 hover:text-red-500"
                                    (click)="viewData(role.roleId,'Delete')">
                                    <span class="material-symbols-outlined text-[20px]">delete</span>
                                </button>

                            </div>

                        </td>

                    </tr>

                </tbody>

            </table>

        </div>

    </div>

</main>

<!-- MODAL -->
<div *ngIf="isModalOpen" class="fixed inset-0 bg-black/40 flex items-center justify-center z-50">

    <div class="bg-white w-[525px] rounded-xl shadow-xl">

        <!-- Header -->
        <div class="px-5 py-3.5 border-b border-slate-200 flex justify-between items-center bg-slate-50">

            <div>
                <h3 class="text-[18px] font-bold text-slate-900 flex items-center gap-2">
                    <span class="material-symbols-outlined text-[20px]">admin_panel_settings</span>
                    Add New Role
                </h3>

                <p class="text-sm text-slate-500 mt-0.5">
                    Define and configure a new role for the portal.
                </p>
            </div>

            <button class="text-slate-400 hover:text-slate-600" (click)="closeModal()">
                <span class="material-symbols-outlined text-[22px]">close</span>
            </button>

        </div>

        <!-- Body -->
        <div class="p-5 space-y-4">

            <div class="mt-2">

                <div>
                            <label class="block mb-1 text-sm font-semibold text-gray-700">
                                Name
                            </label>

                            <input type="text" [(ngModel)]="nameKh" name="nameKh" required maxlength="100"
                                class="w-full border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
                                placeholder="Enter role name in Khmer" />
                        </div>
                        
                <!-- Language Tabs -->
                <div class="flex border-b border-slate-200 mb-4 gap-6 mt-7">

                    <button
                        *ngFor="let lang of languages"
                        (click)="setTabPopup(lang.languageId)"
                        class="pb-3 px-6 text-base font-semibold border-b-2 transition-all flex items-center gap-2"
                        [class.text-primary]="activeTabPopup === lang.languageId"
                        [class.border-primary]="activeTabPopup === lang.languageId">

                        <img
                        [src]="lang.icon"
                        class="w-6 h-6 rounded-full object-cover border border-slate-200">

                        {{ lang.name }}

                    </button>

                </div>

                <form enctype="multipart/form-data" class="space-y-4">

                     <div *ngIf="activeTabPopup === 1">
                        <div>
                            <label class="block mb-1 text-sm font-semibold text-gray-700">
                                Name
                            </label>

                            <input type="text" [(ngModel)]="nameKh" name="nameKh" required maxlength="100"
                                class="w-full border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
                                placeholder="Enter role name in Khmer" />
                        </div>
                        <div>
                            <label class="block mb-1 text-sm font-semibold text-gray-700">
                                Description
                            </label>

                            <input type="text" [(ngModel)]="descriptionKh" name="descriptionKh" required maxlength="100"
                                class="w-full border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
                                placeholder="Enter role description in Khmer" />
                        </div>
                    </div>

                    <div *ngIf="activeTabPopup === 2">
                        <div>
                            <label class="block mb-1 text-sm font-semibold text-gray-700">
                                Name
                            </label>

                            <input type="text" [(ngModel)]="nameEn" name="nameEn" required maxlength="100"
                                class="w-full border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
                                placeholder="Enter role name in English" />
                        </div>
                        <div>
                            <label class="block mb-1 text-sm font-semibold text-gray-700">
                                Description
                            </label>

                            <input type="text" [(ngModel)]="descriptionEn" name="descriptionEn" required maxlength="100"
                                class="w-full border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
                                placeholder="Enter role description in English" />
                        </div>
                    </div>

                </form>

            </div>

        </div>

        <!-- Footer -->
        <div class="px-5 py-3.5 bg-slate-50 flex justify-end gap-3 border-t border-slate-200">

            <button (click)="save()" *ngIf="isEnableSave" class="btn-primary">
                <span class="material-symbols-outlined text-[18px]">check_circle</span>
                Create
            </button>

            <button (click)="update()" *ngIf="isEnableUpdate" class="btn-warning">
                <span class="material-symbols-outlined text-[18px]">warning</span>
                Update
            </button>

            <button (click)="delete()" *ngIf="isEnableDelete" class="btn-danger">
                <span class="material-symbols-outlined text-[18px]">delete</span>
                Delete
            </button>

        </div>

    </div>
</div>
